import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ReviewTaskForm from './ReviewTaskForm'

import { updateReviewTask } from '../services'
import { handleError } from '../../../helpers'

export default function EditReviewTaskModal({ visible, onClose, reviewTask, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ 
		defaultValues: { 
			task_order: reviewTask.task_order,
			task_name: reviewTask.task_name,
			is_meet: reviewTask.is_meet,
			observations: reviewTask.observations,
		}
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		updateReviewTask(reviewTask.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ReviewTaskForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}